<template>
    <b-form :class="'h-100 w-100'">
        <b-form-row class="d-flex h-100 overflow-hidden" style="flex-wrap: nowrap; margin: 0;">
            <b-col cols="12" :sm="(showPdfPreview) ? 6 : 12" class="companysettings-master-modal--left">
                <overlay-scrollbars :options="{ scrollbars: { autoHide: false }, overflowBehavior: { y: 'scroll', x: 'hidden' }, className : 'os-theme-dark os-theme-gekko' }">
                    <div class="pb-4">

                        <div class="modal-form-legend">
                            <legend v-translate>Company Logo</legend>
                        </div>
                        <b-form-row>
                            <div class="form-logo-frame">
                                <VueDropzone 
                                    :preloaded_file="imageSrc"
                                    :allowed-files="'all'" 
                                    only-change 
                                    @change="fileChanged" 
                                />
                            </div>
                        </b-form-row>

                        <div class="modal-form-legend">
                            <legend v-translate>Details</legend>
                        </div>

                        <b-form-row>
                            <b-col cols="12" lg="6">
                                <b-form-group id="input-group-1" label-class="gk-label-margin gk-modal-label" label-for="input-1">
                                    <template slot="label">
                                        <span v-translate>Name</span>
                                    </template>
                                    <b-input-group>
                                        <b-form-input id="input-1" type="text" v-model="companyDetails.name" :class="[ getHighlightClass('name') ]" :placeholder="$gettext('Gekko')" />
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" lg="6">
                                <b-form-group id="input-group-2" label-class="gk-label-margin gk-modal-label" label-for="input-2">
                                    <template slot="label">
                                        <span v-translate>Email</span>
                                    </template>
                                    <b-input-group>
                                        <b-form-input id="input-2" type="text" v-model="companyDetails.email" :class="[ getHighlightClass('email') ]" :placeholder="$gettext('john.doe@mycompany.com')" />
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-form-row>

                        <b-form-row>
                            <b-col cols="12" lg="6">
                                <b-form-group id="input-group-13" label-class="gk-label-margin gk-modal-label" label-for="input-13">
                                    <template slot="label">
                                        <span v-translate>Website</span>
                                    </template>
                                    <b-input-group>
                                        <b-form-input id="input-13" type="text" v-model="companyDetails.website" :class="[ getHighlightClass('website') ]" :placeholder="$gettext('www.getgekko.com')" />
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" lg="6">
                                <b-form-group id="input-group-3" label-class="gk-label-margin gk-modal-label" label-for="input-3">
                                    <template slot="label">
                                        <span v-translate>Phone Number</span>
                                    </template>
                                    <b-input-group>
                                        <b-form-input id="input-3" type="text" v-model="companyDetails.phone_number" :class="[ getHighlightClass('phone_number') ]" :placeholder="$gettext('0612345678')" />
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-form-row>

                        <b-form-row>
                            <b-col cols="12" lg="6">
                                <b-form-group id="input-group-4" label-class="gk-label-margin gk-modal-label" label-for="input-4">
                                    <template slot="label">
                                        <span v-translate>Type of Business</span>
                                    </template>
                                    <b-input-group>
                                        <b-form-select id="input-4" :options="businessTypesOptions" :class="[ getHighlightClass('legal_form') ]" v-model="companyDetails.legal_form"></b-form-select>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" lg="6">
                                <b-form-group id="input-group-5" label-class="gk-label-margin gk-modal-label" label-for="input-5">
                                    <template slot="label">
                                        <span v-translate>Sector</span>
                                    </template>
                                    <b-input-group>
                                        <b-form-select id="input-5" :options="sectorOptions" :class="[ getHighlightClass('sector') ]" v-model="companyDetails.sector">
                                            <template #first>
                                                <b-form-select-option :value="null" >---------</b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-form-row>

                        <b-form-group id="input-group-14" label-class="gk-label-margin gk-modal-label" label-for="input-14">
                            <template slot="label">
                                <span v-translate>Description</span>
                            </template>
                            <b-input-group>
                                <b-form-input id="input-14" type="text" v-model="companyDetails.description" :class="[ getHighlightClass('description') ]" :placeholder="$gettext('Management and business consultancy')" />
                            </b-input-group>
                        </b-form-group>

                        <div class="modal-form-legend">
                            <legend v-translate>Address</legend>
                        </div>
                        
                        <b-form-row>
                            <b-col cols="12" lg="6">
                                <b-form-group id="input-group-6" label-class="gk-label-margin gk-modal-label" label-for="input-6">
                                    <template slot="label">
                                        <span v-translate>Street</span>
                                    </template>
                                    <b-input-group>
                                        <b-form-input id="input-6" type="text" v-model="companyDetails.address" :class="[ getHighlightClass('address') ]" :placeholder="$gettext('Rokin')" />
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" lg="6">
                                <b-form-group id="input-group-7" label-class="gk-label-margin gk-modal-label" label-for="input-7">
                                    <template slot="label">
                                        <span v-translate>City</span>
                                    </template>
                                    <b-input-group>
                                        <b-form-input id="input-7" type="text" v-model="companyDetails.city" :class="[ getHighlightClass('city') ]" :placeholder="$gettext('Amsterdam')" />
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-form-row>

                        <b-form-row>
                            <b-col cols="12" lg="6">
                                <b-form-group id="input-group-8" label-class="gk-label-margin gk-modal-label" label-for="input-8">
                                    <template slot="label">
                                        <span v-translate>Postal Code</span>
                                    </template>
                                    <b-input-group>
                                        <b-form-input id="input-8" type="text" v-model="companyDetails.postal_code" :class="[ getHighlightClass('postal_code') ]" :placeholder="$gettext('1234AB')" />
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" lg="6">
                                <b-form-group id="input-group-9" label-class="gk-label-margin gk-modal-label" label-for="input-9">
                                    <template slot="label">
                                        <span v-translate>Country</span>
                                    </template>
                                    <b-input-group>
                                        <b-form-select id="input-9" :options="countryOptions" v-model="companyDetails.country" :class="[ getHighlightClass('country') ]" :disabled="true"></b-form-select>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-form-row>

                        <div class="modal-form-legend">
                            <legend v-translate>Identification Numbers</legend>
                        </div>

                        <b-form-row>
                            <b-col cols="12" lg="6">
                                <b-form-group id="input-group-10" label-class="gk-label-margin gk-modal-label" label-for="input-10">
                                <template slot="label">
                                    <span>{{ companyDetails.coc_label }}</span>
                                </template>
                                <b-input-group>
                                    <b-form-input id="input-10" type="text" v-model="companyDetails.kvk" :class="[ getHighlightClass('kvk') ]" :placeholder="$gettext('0123456789')" />
                                </b-input-group>
                            </b-form-group>
                            </b-col>

                            <b-col cols="12" lg="6">
                                <b-form-group id="input-group-11" label-class="gk-label-margin gk-modal-label" label-for="input-11">
                                    <template slot="label">
                                        <span v-translate>VAT</span>
                                    </template>
                                    <b-input-group>
                                        <b-form-input id="input-11" type="text" v-model="companyDetails.btw" :class="[ getHighlightClass('btw') ]" :placeholder="$gettext('NL012345678B00')" />
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                        
                        <b-form-group id="input-group-12" label-class="gk-label-margin gk-modal-label" label-for="input-12">
                            <template slot="label">
                                <span v-translate>Bank Account Number</span>
                            </template>
                            <b-input-group>
                                <b-form-input id="input-12" type="text" v-model="companyDetails.bank_account_number" :class="[ getHighlightClass('bank_account_number') ]" :placeholder="$gettext('NLINGB000000123456789')" />
                            </b-input-group>
                        </b-form-group>
                    </div>
                </overlay-scrollbars>
            </b-col>

            <b-col v-if="showPdfPreview" cols="12" sm="6" class="companysettings-master-modal--right modal-dropzone-actions pr-0 overflow-hidden">
                <div class="modal-dropzone-actions--wrap" style="display: flex; flex-direction: column; gap: 0.5rem; height: 100%;">
                    <div style="height: calc(100% - 40px);">
                        <InvoiceDesign  :key="previewKey" :show-controls="false" />
                    </div>
                    <div class="text-center">
                        <GekkoButton
                        @click="$emit('edit-design')"
                        :text="$gettext('Edit design')" 
                        icon="fa-solid fa-paintbrush"
                        class="text-info"
                        variant="link"
                        size="sm"
                        />
                    </div>
                </div>
            </b-col>

        </b-form-row>
    </b-form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import CompanyService from "@/store/services/company.service";

import GekkoButton from "@/components/GekkoButton"
import VueDropzone from "@/components/VueDropzone"
import InvoiceDesign from "@/views/settings/InvoiceDesign"

export default {
    name: "EditCompanyProfile",
    components: {
        GekkoButton,
        VueDropzone,
        InvoiceDesign
    },
    props: {
        selectedCompany: {
            type: Object,
            default() {return null}
        },
        targetData: {
            type: Array,
            default: () => []
        },
        showPdfPreview: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            companyDetails: {},
            countryOptions: null,
            sectorOptions: null,
            businessTypesOptions: null,
            kvk_legal_form_options: null,
            imageSrc: null,
            previewKey: 0
        }
    },
    computed: {
        ...mapGetters({
            currentCompany: "main/getCurrentCompany"
        })
    },
    created () {
        this.companyDetails = JSON.parse(JSON.stringify(this.currentCompany));

        CompanyService.getAllChoices().then((response) => {
            this.countryOptions = response.data.countries;
            this.sectorOptions = response.data.sectors;
            if (this.currentCompany.country === "ES") this.businessTypesOptions = response.data.business_entities.es;
            else this.businessTypesOptions = response.data.business_entities.nl;
            this.kvk_legal_form_options = response.data.kvk_legal_form_options;
        });
        
        if (this.companyDetails.logo) {
          this.imageSrc = this.companyDetails.logo
        } else {
          this.imageSrc = null
        }
        
        if (this.selectedCompany) {
            this.companyDetails.name = this.selectedCompany.naam;
            this.companyDetails.city = this.selectedCompany.plaats;
            this.companyDetails.address = this.selectedCompany.straatnaam;
            this.companyDetails.kvk = this.selectedCompany.kvkNummer;

            let params = {url: this.selectedCompany.links[0].href};
            CompanyService.getKvkPageByUrl(params).then((response) => {
                if ('hoofdvestiging' in response.data['_embedded'] && response.data['_embedded']['hoofdvestiging']['adressen']) {
                    let address = response.data['_embedded']['hoofdvestiging']['adressen'][0];

                    let street_address = '';
                    if (address['straatnaam'])
                        street_address = address['straatnaam'];
                    if (address['huisnummer'])
                        street_address = street_address + ' ' + address['huisnummer'];
                    if (address['huisnummertoevoeging'])
                        street_address = street_address + '-' + address['huisnummertoevoeging'];

                    this.companyDetails.address = street_address;
                    this.companyDetails.postal_code = address['postcode'];
                    this.companyDetails.city = address['plaats'];
                }
                
                let business_activities = response.data['sbiActiviteiten'][0];
                this.companyDetails.description = business_activities['sbiOmschrijving'];
                this.companyDetails.sbi_description = business_activities['sbiOmschrijving'];
                this.companyDetails.sbi_code = business_activities['sbiCode'];

                if (response.data['_embedded']['hoofdvestiging']['websites'])
                    this.companyDetails.website = response.data['_embedded']['hoofdvestiging']['websites'][0];
                
                if (this.kvk_legal_form_options) {
                    if (response.data['_embedded']['eigenaar']['rechtsvorm'] in this.kvk_legal_form_options)
                        this.companyDetails.legal_form = this.kvk_legal_form_options[response.data['_embedded']['eigenaar']['rechtsvorm']];
                }
            });
        }
    },
    methods: {
        ...mapActions({ 
            loadCurrentCompany: "main/loadCurrentCompany"
        }),
        getHighlightClass (target_field) {
            let cssClass = ''
            const isRequired = this.targetData.find(o => o.key === target_field)
            if (isRequired) {
                cssClass = (!this.companyDetails[target_field]) ? 'emptyrequired' : ''
            }
            return cssClass
        },
        saveCompanyData() {
            // avoid 400 error because it expects an image file (not the file path)
            if (!(this.companyDetails.logo instanceof File)) {
                delete this.companyDetails.logo;
            }
            CompanyService.update(this.companyDetails).then(() => {
                this.$store.commit("setAlert", {
                    title: this.$gettext("Success!"),
                    text: this.$gettext("The company details were updated correctly."),
                    variant: "success",
                    duration: 4
                });
                this.loadCurrentCompany(); // refresh store
                this.$emit("detailsSaved");
                this.previewKey++
            }).catch(() => {
                this.$store.commit("setAlert", {
                    title: this.$gettext("Error"),
                    text: this.$gettext("The company details could not be saved."),
                    variant: "danger",
                    duration: 4
                });
            });

        },
        fileChanged (file) {
            this.$set(this.companyDetails, 'logo', file)
        },
    }
}
</script>

<style lang="scss">
    .gk-modal {
        .form-control.emptyrequired, .custom-select.emptyrequired {
            border: 3px solid $colorBlue;
        }
    }

  .companysettings-master-modal--left {
    .os-content {
      padding: 1rem !important;
    }
  }

</style>

<style lang="scss" scoped>
  .modal-dropzone-actions {
    .modal-dropzone-actions--wrap {
      .modal-dropzone-wrapper {
        flex: 1;
        height: 100%;
      }
    }
  }
  .modal-content {
    height: 100%;
    overflow: hidden;
  }
    .companysettings-master-modal--right {
        padding: 1rem !important;
        padding-left: 0 !important;
    }
</style>